import React, { useState, useEffect } from 'react';
import { getProveedores, createProveedor, updateProveedor, deleteProveedor, getComunidades, getConfiguracionSistema } from '../services/api';
import { useToast } from '../components/Toast';
import ConfirmModal from '../components/ConfirmModal';

function Proveedores() {
  const toast = useToast();
  const [proveedores, setProveedores] = useState([]);
  const [comunidades, setComunidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingProveedor, setEditingProveedor] = useState(null);
  const [user, setUser] = useState(null);
  const [selectedComunidad, setSelectedComunidad] = useState('');
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    email: '',
    servicio: '',
    comunidades_ids: []
  });
  const [confirmModal, setConfirmModal] = useState({ isOpen: false, title: '', message: '', onConfirm: null });
  const [config, setConfig] = useState({ asignacion_proveedores_activa: true, es_superadmin: false });

  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const userData = JSON.parse(userStr);
      setUser(userData);
      if (userData.rol === 'administrador') {
        cargarComunidades();
      }
    }
    cargarProveedores();
    getConfiguracionSistema().then(r => setConfig(r.data)).catch(() => {});
  }, []);

  const cargarProveedores = async (comunidad_id = null) => {
    try {
      const response = await getProveedores(comunidad_id);
      setProveedores(response.data);
    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al cargar los proveedores');
    } finally {
      setLoading(false);
    }
  };

  const cargarComunidades = async () => {
    try {
      const response = await getComunidades();
      setComunidades(response.data);
    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al cargar las comunidades');
    }
  };

  const handleFilterChange = (comunidad_id) => {
    setSelectedComunidad(comunidad_id);
    cargarProveedores(comunidad_id || null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleComunidadToggle = (comunidadId) => {
    const id = Number(comunidadId);
    setFormData(prev => {
      const current = prev.comunidades_ids || [];
      if (current.includes(id)) {
        return { ...prev, comunidades_ids: current.filter(c => c !== id) };
      } else {
        return { ...prev, comunidades_ids: [...current, id] };
      }
    });
  };

  const handleSelectAllComunidades = () => {
    const allIds = comunidades.map(c => c.id);
    const allSelected = allIds.every(id => formData.comunidades_ids.includes(id));
    setFormData(prev => ({
      ...prev,
      comunidades_ids: allSelected ? [] : allIds
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        nombre: formData.nombre,
        telefono: formData.telefono,
        email: formData.email,
        servicio: formData.servicio,
        comunidades_ids: formData.comunidades_ids
      };
      if (editingProveedor) {
        await updateProveedor(editingProveedor.id, payload);
        toast.success('Proveedor actualizado con éxito');
      } else {
        await createProveedor(payload);
        toast.success('Proveedor creado con éxito');
      }
      setShowModal(false);
      setEditingProveedor(null);
      setFormData({
        nombre: '',
        telefono: '',
        email: '',
        servicio: '',
        comunidades_ids: []
      });
      cargarProveedores(selectedComunidad || null);
    } catch (error) {
      toast.error('Error: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleEdit = (proveedor) => {
    setEditingProveedor(proveedor);
    setFormData({
      nombre: proveedor.nombre,
      telefono: proveedor.telefono,
      email: proveedor.email || '',
      servicio: proveedor.servicio || '',
      comunidades_ids: proveedor.comunidades_ids || (proveedor.comunidad_id ? [proveedor.comunidad_id] : [])
    });
    setShowModal(true);
  };

  const openConfirm = (title, message, onConfirm) => {
    setConfirmModal({ isOpen: true, title, message, onConfirm });
  };
  const closeConfirm = () => setConfirmModal(prev => ({ ...prev, isOpen: false }));

  const handleDelete = (id) => {
    openConfirm(
      'Eliminar proveedor',
      '¿Estás seguro de que quieres eliminar este proveedor? Esta acción no se puede deshacer.',
      async () => {
        closeConfirm();
        try {
          await deleteProveedor(id);
          toast.success('Proveedor eliminado con éxito');
          cargarProveedores(selectedComunidad || null);
        } catch (error) {
          toast.error('Error al eliminar proveedor');
        }
      }
    );
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingProveedor(null);
    setFormData({
      nombre: '',
      telefono: '',
      email: '',
      servicio: '',
      comunidades_ids: []
    });
  };

  return (
    <div className="container" style={{ paddingTop: '40px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px', flexWrap: 'wrap', gap: '12px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: '700' }}>🏗️ Gestión de Proveedores</h1>
        <button onClick={() => {
          setFormData({ nombre: '', telefono: '', email: '', servicio: '', comunidades_ids: comunidades.map(c => c.id) });
          setShowModal(true);
        }} className="btn btn-primary">
          + Nuevo Proveedor
        </button>
      </div>


      {user?.rol === 'administrador' && comunidades.length > 0 && (
        <div className="card" style={{ marginBottom: '24px' }}>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label className="form-label">Filtrar por comunidad</label>
            <select
              className="form-control"
              value={selectedComunidad}
              onChange={(e) => handleFilterChange(e.target.value)}
            >
              <option value="">Todas las comunidades</option>
              {comunidades.map(com => (
                <option key={com.id} value={com.id}>{com.nombre}</option>
              ))}
            </select>
          </div>
        </div>
      )}

      {loading ? (
        <div className="loading"><div className="spinner"></div></div>
      ) : proveedores.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', padding: '48px' }}>
          <p style={{ color: 'var(--text-secondary)' }}>No hay proveedores registrados</p>
        </div>
      ) : (
        <div className="card">
          <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Teléfono</th>
                <th>Email</th>
                <th>Servicio</th>
                {user?.rol === 'administrador' && <th>Comunidades</th>}
                <th style={{ textAlign: 'right' }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {proveedores.map(proveedor => (
                <tr key={proveedor.id}>
                  <td style={{ fontWeight: '600' }}>{proveedor.nombre}</td>
                  <td>
                    <a href={`tel:${proveedor.telefono}`} style={{ color: 'var(--primary)', textDecoration: 'none' }}>
                      {proveedor.telefono}
                    </a>
                  </td>
                  <td>
                    {proveedor.email ? (
                      <a href={`mailto:${proveedor.email}`} style={{ color: 'var(--primary)', textDecoration: 'none' }}>
                        {proveedor.email}
                      </a>
                    ) : (
                      <span style={{ color: 'var(--text-secondary)' }}>-</span>
                    )}
                  </td>
                  <td>{proveedor.servicio || <span style={{ color: 'var(--text-secondary)' }}>-</span>}</td>
                  {user?.rol === 'administrador' && (
                    <td>
                      {proveedor.comunidades_nombres || (
                        <span style={{ color: 'var(--text-secondary)' }}>Sin comunidad</span>
                      )}
                    </td>
                  )}
                  <td style={{ textAlign: 'right' }}>
                    <button
                      onClick={() => handleEdit(proveedor)}
                      className="btn btn-sm btn-outline"
                      style={{ marginRight: '8px' }}
                    >
                      Editar
                    </button>
                    <button
                      onClick={() => handleDelete(proveedor.id)}
                      className="btn btn-sm btn-danger"
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      )}

      {showModal && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingProveedor ? 'Editar Proveedor' : 'Nuevo Proveedor'}</h2>
              <button onClick={closeModal} className="modal-close">&times;</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group">
                  <label className="form-label">Nombre *</label>
                  <input
                    type="text"
                    name="nombre"
                    className="form-control"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Teléfono *</label>
                  <input
                    type="tel"
                    name="telefono"
                    className="form-control"
                    value={formData.telefono}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Servicio</label>
                  <input
                    type="text"
                    name="servicio"
                    className="form-control"
                    value={formData.servicio}
                    onChange={handleChange}
                    placeholder="Ej: Fontanería, Electricidad, Limpieza..."
                  />
                </div>
                {user?.rol === 'administrador' && (
                  <div className="form-group">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                      <label className="form-label" style={{ marginBottom: 0 }}>Comunidades *</label>
                      <button
                        type="button"
                        onClick={handleSelectAllComunidades}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: 'var(--primary)',
                          cursor: 'pointer',
                          fontSize: '13px',
                          padding: '2px 6px'
                        }}
                      >
                        {comunidades.length > 0 && comunidades.every(c => formData.comunidades_ids.includes(c.id))
                          ? 'Deseleccionar todas'
                          : 'Seleccionar todas'}
                      </button>
                    </div>
                    <div style={{
                      border: '1px solid var(--border)',
                      borderRadius: '8px',
                      maxHeight: '180px',
                      overflowY: 'auto',
                      padding: '8px'
                    }}>
                      {comunidades.map(com => (
                        <label
                          key={com.id}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '6px 8px',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            transition: 'background 0.15s',
                            background: formData.comunidades_ids.includes(com.id) ? 'rgba(59, 130, 246, 0.1)' : 'transparent'
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={formData.comunidades_ids.includes(com.id)}
                            onChange={() => handleComunidadToggle(com.id)}
                            style={{ accentColor: 'var(--primary)', width: '16px', height: '16px' }}
                          />
                          <span style={{ fontSize: '14px' }}>{com.nombre}</span>
                        </label>
                      ))}
                    </div>
                    {formData.comunidades_ids.length > 0 && (
                      <p style={{ fontSize: '12px', color: 'var(--text-secondary)', marginTop: '6px' }}>
                        {formData.comunidades_ids.length} comunidad{formData.comunidades_ids.length !== 1 ? 'es' : ''} seleccionada{formData.comunidades_ids.length !== 1 ? 's' : ''}
                      </p>
                    )}
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" onClick={closeModal} className="btn btn-outline">
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  {editingProveedor ? 'Guardar Cambios' : 'Crear Proveedor'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <ConfirmModal
        isOpen={confirmModal.isOpen}
        title={confirmModal.title}
        message={confirmModal.message}
        onConfirm={confirmModal.onConfirm}
        onCancel={closeConfirm}
        confirmLabel="Eliminar"
        variant="danger"
      />
    </div>
  );
}

export default Proveedores;
